export function equalToFieldValidation(
  value?: string,
  valueToCompare?: string
) {
  if (value && valueToCompare && value === valueToCompare) {
    return true;
  }
  return false;
}
